export default "__VITE_ASSET__tH9g7PK0__"